import { lazy } from "react";

import type { NavigationRoutingObject } from "@navigationRouting/types";

import type { I18nT } from "@lib/dashboardI18n";

const ConversationalSimulationsPageForNRO = lazy(() =>
  import("@scenes/ConversationalSimulations").then((module) => ({
    default: module.ConversationalSimulationsPage,
  }))
);

export const conversationalSimulationsNRO: NavigationRoutingObject = {
  Component: ConversationalSimulationsPageForNRO,
  noKnockoutFallback: true,
  componentFeatureFlippers: [],
  section: "agent-console",
  heading: (t: I18nT<"dashboard-navigation">) => t("conversational-simulations-nro-heading", "Simulations"),
  pageNameForTracking: () => "Conversational Simulations",
  getDeveloperNavigationAllowed: ({ featureOn }) => {
    return featureOn("agent_console_conversational");
  },
  additionalSearchTerms: () => [],
  additionalSearchableFeatures: () => ({}),
};
